export default class MatchKeyDetailsController {

  constructor(MatchKeyDetailsService) {
    this.MatchKeyDetailsService = MatchKeyDetailsService;
  }
};

MatchKeyDetailsController.$inject = ['MatchKeyDetailsService'];



// WEBPACK FOOTER //
// ./modules/controllers/match-key-details.controller.js